import { Polygon } from "geojson";

export type Info = {
  id: number;
  poiId: number;
  name: string;
  priority: number;
  lang: null;
  poiTypeId: null | number;
};

export type MapData = {
  poiId: number;
  nodeId: number | null;
  geometry: Polygon;
  campusId: number;
  floorId: number;
  floorName: string;
  buildingId: number;
  buildingName: string;
  identifierId: string | null;
  identifier: string | null;
  deleted: boolean;
  infos: Info[];
  z: number;
  infoUrl: string | null;
  title: string | null;
  peopleCapacity: number | null;
  description: string | null;
  images: [];
};

export type LaundretteDetails = {
  Notes: string | null;
  PictureURL: string | null;
  siteId: number;
  mapData?: MapData | null;
  lat: number;
  lng: number;
};

export const laundretteList: { [key: string]: LaundretteDetails } = {
  "LONSDALE LAUNDERETTE": {
    Notes:
      "The Lonsdale Circuit Managed Laundry System contains 8 washers and 8 dryers.\nOpen 24 hours a day.",
    PictureURL:
      "https://portal.ombiel.co.uk/assets/LancasterStudents/Map_and_Photos/Map_Images/lonsdale_laund.jpg",
    siteId: 6080,
    mapData: {
      poiId: 857080,
      nodeId: null,
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.7895694293303483, 54.00510125499946],
            [-2.7895076770055423, 54.00510164665425],
            [-2.78950723123601, 54.00507738256629],
            [-2.789568983560809, 54.00507699091129],
            [-2.7895694293303483, 54.00510125499946],
          ],
        ],
      },
      campusId: 341,
      floorId: 9006,
      floorName: "1",
      buildingId: 2645,
      buildingName: "Lonsdale House",
      identifierId: null,
      identifier: "32412",
      title: "Laundrette",
      deleted: false,
      infos: [
        {
          id: 19184958,
          poiId: 857080,
          name: "A13",
          priority: 20,
          lang: null,
          poiTypeId: null,
        },
        {
          id: 19184957,
          poiId: 857080,
          name: "Laundrette",
          priority: 20,
          lang: null,
          poiTypeId: null,
        },
      ],
      z: 1,
      infoUrl: "https://www.circuit.co.uk/how-to-guides/mobile-app/",
      description: "Webpage for Circuit",
      images: [],
      peopleCapacity: null,
    },
    lat: 54.00509007888951,
    lng: -2.7895457656573512,
  },
  "PENDLE LAUNDERETTE": {
    Notes: "The Pendle Circuit Managed Laundry System.\nOpen: 08:00 - 23:00.",
    PictureURL: null,
    siteId: 6389,
    mapData: {
      poiId: 1032171,
      nodeId: null,
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.785298440160952, 54.00647078996292],
            [-2.7853167955523377, 54.00649420733305],
            [-2.785246450838993, 54.00651325155747],
            [-2.7852139620956686, 54.00647180320436],
            [-2.7852297054791113, 54.00646754103939],
            [-2.785243838831055, 54.006485572034954],
            [-2.785298440160952, 54.00647078996292],
          ],
        ],
      },
      campusId: 341,
      floorId: 10606,
      floorName: "1",
      buildingId: 3020,
      buildingName: "Pendle College - Block 12",
      identifierId: null,
      identifier: null,
      title: null,
      deleted: false,
      infos: [],
      z: 1,
      infoUrl: null,
      description: null,
      images: [],
      peopleCapacity: null,
    },
    lat: 54.006495084650254,
    lng: -2.785261155574915,
  },
  "GRIZEDALE COLLEGE": {
    Notes:
      "The Grizedale Circuit Managed Laundry System contains 5 washers and 5 dryers.\nOpen 24 hours a day.",
    PictureURL:
      "https://portal.ombiel.co.uk/assets/LancasterStudents/Map_and_Photos/Map_Images/grizedale_laund.jpg",
    siteId: 1000, //NO ID FOUND
    lat: 54.006749,
    lng: -2.785173,
  },
  "CHANCELLORS WHARF": {
    Notes: null,
    PictureURL: null,
    siteId: 5275,
    lat: 54.043282,
    lng: -2.801594,
  },
  "COUNTY SOUTH": {
    Notes: null,
    PictureURL:
      "https://portal.ombiel.co.uk/assets/LancasterStudents/Campus-Images/Optimized-Pics/county1.png",
    siteId: 5394,
    mapData: {
      poiId: 869192,
      nodeId: null,
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.7848653522590445, 54.011744904787825],
            [-2.7848362672961, 54.01174899573334],
            [-2.784811330439054, 54.01168777789277],
            [-2.784840415398748, 54.011683686941666],
            [-2.7848653522590445, 54.011744904787825],
          ],
        ],
      },
      campusId: 341,
      floorId: 9066,
      floorName: "1",
      buildingId: 2662,
      buildingName: "County South",
      identifierId: null,
      identifier: "10865",
      title: "Laundrette",
      deleted: false,
      infos: [
        {
          id: 19107783,
          poiId: 869192,
          name: "A025",
          priority: 20,
          lang: null,
          poiTypeId: null,
        },
        {
          id: 19058725,
          poiId: 869192,
          name: "Laundrette",
          priority: 20,
          lang: null,
          poiTypeId: null,
        },
      ],
      z: 1,
      infoUrl: "https://www.circuit.co.uk/how-to-guides/mobile-app/",
      description: "Webpage for Circuit",
      images: [],
      peopleCapacity: null,
    },
    lat: 54.01170508894987,
    lng: -2.7848366267414804,
  },
  "COUNTY MAIN": {
    Notes:
      "The County Main Circuit Managed Laundry System contains 13 washers and 15 dryers.\nOpen 24 hours a day.",
    PictureURL:
      "https://portal.ombiel.co.uk/assets/LancasterStudents/Campus-Images/Optimized-Pics/washing.png",
    siteId: 5393,
    mapData: {
      poiId: 867012,
      nodeId: null,
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.783462843768192, 54.013013535985046],
            [-2.7835301948508593, 54.01300285021156],
            [-2.783536771610654, 54.01301731029905],
            [-2.7835560652208358, 54.01301428052062],
            [-2.783574077381875, 54.01305388319463],
            [-2.7834961714186592, 54.01306611718835],
            [-2.7834850384656065, 54.01306233464301],
            [-2.783462843768192, 54.013013535985046],
          ],
        ],
      },
      campusId: 341,
      floorId: 9043,
      floorName: "1",
      buildingId: 2655,
      buildingName: "County Main",
      identifierId: null,
      identifier: "30131",
      title: "Laundrette",
      deleted: false,
      infos: [
        {
          id: 19106247,
          poiId: 867012,
          name: "A042",
          priority: 20,
          lang: null,
          poiTypeId: null,
        },
        {
          id: 19058085,
          poiId: 867012,
          name: "Laundrette",
          priority: 20,
          lang: null,
          poiTypeId: null,
        },
      ],
      z: 1,
      infoUrl: "https://www.circuit.co.uk/how-to-guides/mobile-app/",
      description: "Webpage for Circuit",
      images: [],
      peopleCapacity: null,
    },
    lat: 54.013050100494894,
    lng: -2.7835275208952623,
  },
  "FURNESS LAUNDERETTE": {
    Notes:
      "Furness and Fylde shared, this Laundrette contains 12 washers and 12 dryers. \nOpen: 8:00 - 23:00",
    PictureURL:
      "https://portal.ombiel.co.uk/assets/LancasterStudents/Campus_2/Launderette-2.jpg",
    siteId: 1000, //NO ID FOUND
    mapData: {
      poiId: 937467,
      nodeId: null,
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.7852775054143253, 54.00901780898946],
            [-2.785280340376154, 54.00905650209962],
            [-2.7852847976062365, 54.009056389320904],
            [-2.7852837939044477, 54.009042690253565],
            [-2.7852838895260317, 54.00904261955705],
            [-2.785283093729315, 54.00903175808811],
            [-2.7853417018469586, 54.00903032508659],
            [-2.7853422960296217, 54.00903745815277],
            [-2.7853185016173567, 54.009038250353306],
            [-2.7853188547408125, 54.009040720178376],
            [-2.7853255567496182, 54.00904055060702],
            [-2.785327569290322, 54.00906801898654],
            [-2.785319238449556, 54.009068280370975],
            [-2.785319494551834, 54.00907060089102],
            [-2.7853250661281854, 54.009070470103374],
            [-2.7853261549111736, 54.00908533039449],
            [-2.785306144466466, 54.00908581704266],
            [-2.785306200805237, 54.00908658614703],
            [-2.785193866113288, 54.00908951546219],
            [-2.7851940580256715, 54.00909213478415],
            [-2.7851751147977812, 54.00909261409334],
            [-2.7851753386955536, 54.009095669968666],
            [-2.785069642912571, 54.00909834432568],
            [-2.785069502176826, 54.00909642348991],
            [-2.78506727356178, 54.0090964798792],
            [-2.785066313999812, 54.00908338326924],
            [-2.7850685426148813, 54.00908332687988],
            [-2.7850682355550314, 54.009079135963844],
            [-2.7851672409775854, 54.00907665495745],
            [-2.785162956691836, 54.00902062106418],
            [-2.7852775054143253, 54.00901780898946],
          ],
        ],
      },
      campusId: 341,
      floorId: 9464,
      floorName: "-1",
      buildingId: 2750,
      buildingName: "Furness College",
      identifierId: null,
      identifier: null,
      title: "Fylde and Furness Laundrette",
      deleted: false,
      infos: [
        {
          id: 19218258,
          poiId: 937467,
          name: "Fylde and Furness Laundrette",
          priority: -20,
          lang: null,
          poiTypeId: null,
        },
        {
          id: 19218257,
          poiId: 937467,
          name: "Laundrette",
          priority: 300,
          lang: null,
          poiTypeId: null,
        },
      ],
      z: -1,
      infoUrl: null,
      description: null,
      images: [],
      peopleCapacity: null,
    },
    lat: 54.00907403157069,
    lng: -2.785256466220261,
  },
  "NEW CARTMEL (SOUTH WEST CAMPUS)": {
    Notes:
      "The Cartmel Circuit Managed Laundry System contains 10 washers and 12 dryers.\nOpen: 08:00 - 23:00.",
    PictureURL:
      "https://portal.ombiel.co.uk/assets/LancasterStudents/Map_and_Photos/Map_Images/cartmel_laund.jpg",
    siteId: 6264,
    lat: 54.003824,
    lng: -2.788096,
  },
};
